import script from "./MessageChatComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageChatComponent.vue?vue&type=script&lang=ts&setup=true"

import "./MessageChatComponent.vue?vue&type=style&index=0&id=85956e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85956e94"]])

export default __exports__